var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarCompaniesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5641 42H42V20.9744L24.5641 17.3846M24.5641 42V17.3846M24.5641 42H17.3846M24.5641 17.3846V6.10256L2 2V42H9.17949M9.17949 42V31.2308H17.3846V42M9.17949 42H17.3846M8.15385 26.1026H10.2051M16.359 26.1026H18.4103M8.15385 20.9744H10.2051M16.359 20.9744H18.4103M18.4103 15.8462H16.359M10.2051 15.8462H8.15385M8.15385 10.7179H10.2051M16.359 10.7179H18.4103M31.7436 26.1026H34.3077M34.3077 31.2308H31.7436M31.7436 36.359H34.3077",
    stroke: "#1347D7",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCompaniesIcon);
export default __webpack_public_path__ + "static/media/sidebarCompaniesIcon.18f23fdfee63abeaf52f19791b2d063f.svg";
export { ForwardRef as ReactComponent };